import posed from "react-pose"

const HoverGrow = posed.div({
  hoverable: true,
  init: { scale: 1 },
  hover: { scale: 1.05 }
})

export default HoverGrow
